import { gql } from "@apollo/client";
import {
  CustomerNoNestingFragment,
  LocationNoNestingFragment,
  PaymentNoNestingFragment,
  SaleAdjustmentNoNestingFragment,
  SaleFragment,
  SaleLineItemNoNestingFragment,
  StaffNoNestingFragment,
  TerminalNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const createSale = gql`
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation createSale($input: CreateSaleInput!) {
    createSale(input: $input) {
      ...Sale
      isReturn
      returnForId
      lineItems {
        ...SaleLineItemNoNesting
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const updateSale = gql`
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation updateSale($input: UpdateSaleInput!) {
    updateSale(input: $input) {
      ...Sale
      isReturn
      returnForId
      lineItems {
        ...SaleLineItemNoNesting
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const QUERY_LIST_SALES = gql`
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  query sales($options: SaleListOptions) {
    sales(options: $options) {
      items {
        ...Sale
        isReturn
        returnForId
        lineItems {
          ...SaleLineItemNoNesting
          adjustments {
            ...SaleAdjustmentNoNesting
          }
        }
      }
    }
  }
`;
